import { getOne, getListEmployees, searchBar, getCollectsBetweenDates } from "../../Provider";

export function GetDeliveryInfoService(id) {
  return getOne(id);
}

export function GetDeliveryListService(zone) {
  return getListEmployees("deliveryman", zone);
}

export function GetDeliveryListBySearchBarService(zone, name){
  return searchBar("deliveryman", zone, name);
}

export function RegisterDeliveryService(userModel, password) {
  // const body = { ...userModel, password };
  // return createOne("dealers", body);
}

export async function GetCollectsBetweenDatesService(data){
  return getCollectsBetweenDates(data);
}